var React = require('react');
import { Link, browserHistory } from 'react-router';
var PropTypes = React.PropTypes;
var Auth = require("../../resources/auth");

import CircularProgress from 'material-ui/CircularProgress';
// import RaisedButton from 'material-ui/RaisedButton';
import '../../css/components/Students/students.css';
import '../../css/components/StudentAnalytics/ViewStudentMistakesBank.css';
// import { Pager } from 'react-bootstrap';

// import StudentsTable from './StudentsTable';
import MistakesBankTable from './MistakesBankTable';
import MistakesBankRow from './MistakesBankRow';
var StudentRes = require('../../resources/student');
var AnalyticsRes = require('../../resources/analytics');

const STUDENT_STATUSES = [{
  // title: 'Draft',
  // code: 'draft',
  // value: ['self'],
  // actions: ['edit', 'delete'],
  // count: '-',
  cols: ['firstName', 'lastName', 'email', 'phone', 'residentialAddress', 'schoolName', 'class', 'SA2Grade', 'parentName' ,'parentNo', 'parentEmail', 'lastActivityDate'],
  notes: [
    ''
  ]
}];

const MATH_ID = 'a234e6f6-a3ee-4bfe-9143-5c52f89ac84c';
const SCIENCE_ID = '84c52703-3e79-4f8d-8376-d854093843c1';

const ITEM_LIMIT = 20;
var ViewStudentMistakesBank = React.createClass({
  componentWillReceiveProps: function(nextProps) {
    this.setState({})
  },
  onSortChange: function(newSort) {
    // this.setState({
    //   sort: newSort,
    //   studentsData: [],
    //   isLoading: true,
    //   currentPager: 1,
    // }, () => {
    //   this.retrieveStudents();
    // });
  },
  getInitialState: function() {
    return {
        _id: '',
        firstName: '',
        lastName: '',
        email: '',
        statusMode: [],
        currentMode: {},
        isLoading: true,
        mathButtonStyle: "mistakesButton mbSelected",
        scienceButtonStyle: "mistakesButton",
        mistakesData: [],
        courseID: MATH_ID,
        concepts:[]
      // conceptsMap: null,
    };
  },
  handleChangeData: function(e) {
    // var update = {};
    // update[field] = e.target.value;
    // this.setState(update);
    // var searchName = this.state.searchStudentName;
    // this.setState({
    //   searchStudentName: e.target.value,
    //   studentsData: [],
    //   isLoading: true,
    //   currentPager: 1,
    //   sort: 'firstName'
    // }, () => {
    //   this.retrieveStudents(this.state.searchStudentName,this.state.searchStudentName);
    // });
  },
  submit: function() {
    // var _this = this;
    // var oldPassword = _this.state.currentPassword;
    // var newPassword = _this.state.newPassword;
    // var confirmPassword = _this.state.confirmPassword;
    // if (!oldPassword || !newPassword || !confirmPassword) return alert('Please input all fields');
    // if (newPassword !== confirmPassword) return alert('New password not match');
    // _this.setState({
    //   isLoading: true
    // })
    // Auth.changePassword({
    //   "oldPassword": oldPassword,
    //   "newPassword": newPassword
    // }, function(err, res) {
    //   _this.setState({
    //     isLoading: false
    //   })
    //   if (err && err.response && err.response.text === 'WRONG_PASSWORD') return alert('Wrong password');
    //   if (err) return alert('Error occurred. Please try again later');
    //   alert('Change password success');
    // })
  },
  componentDidMount: function() {

    var _this = this;
    var statusMode = this.state.statusMode;
    statusMode = STUDENT_STATUSES;
    var currentUser = Auth.getCurrentUser();

    var currentURL = window.location.href;
    currentURL = currentURL.split("/");
    var studentID = currentURL[currentURL.length-1]; //get the current class ID
    
    // if (currentUser.status.indexOf('reviewer') >= 0) return browserHistory.push('/review-tasks');
    // if (currentUser.role === 'admin') {
    //   statusMode = ADMIN_STATUSES;
    // } else  {
    //   statusMode = TEACHER_STATUSES;
    // }
    var currentMode = statusMode[0];
    if (this.props.location.query.mode) {
      var mode = this.props.location.query.mode,
          mappedMode = statusMode.filter((value) => {
            return value.code === mode
          })[0];
      if (mappedMode) currentMode = mappedMode;
    }
    this.setState({
        _id: studentID,
        isLoading: true,
        statusMode: statusMode,
        currentMode: currentMode
    }, function() {
      // var count = statusMode.length;
      // for (var i = 0; i < statusMode.length; i++) {
      //   this.countCollectionInMode(statusMode[i], function() {
      //     count--;
      //     if (count <= 0) _this.forceUpdate();
      //   });
      // }
      this.retrieveStudent();
      // this.retrieveMistakes();
    });
  },
  retrieveStudent: function(fName,lName,callback) {
    callback = callback || function(){};
    var _this = this;
    var currentPager = this.state.currentPager;
    var options = {};
    options.skip = ITEM_LIMIT * (currentPager - 1);
    options.limit = ITEM_LIMIT;
    // options.sort = this.state.sort || "dateCreated";
    options.conditions = {};
    // options.conditions.status = {
    //   "$in": this.state.currentMode.value
    // }
    // if (!this.state.currentMode.canApplyAdminRole) {
    //   options.conditions.creator = Auth.getCurrentUser()._id;
    // }
    // if (this.state.currentMode.include) {
    //   options.include = this.state.currentMode.include;
    //   options.includeConditions = includeConditions[options.include];
    // }
          // console.log("state of mdoe is " + this.state.currentMode.cols);
    
    // var currentURL = window.location.href;
    // currentURL = currentURL.split("/");
    var studentID = this.state._id;//currentURL[currentURL.length-1]; //get the current class ID

    options.conditions.sort = this.state.sort || "firstName";
    // options.conditions.status = 'student';
    options.conditions.studentID = studentID;

    // var firstN = '';
    // var lastN = '';
    // if (fName) { firstN = fName; }
    // if (lName) { lastN = lName; }

    // options.conditions.sort = this.state.sort || "dateCreated";
    options.conditions.status = 'student';
    // options.conditions.firstName = firstN;
    // options.conditions.lastName = lastN;
    StudentRes.retrieveStudent(options, function(err, res) {
      // console.log("BEFORE DON sdfdsfsE!!");
      // if (callback) return callback(err, res);

    //   console.log("RES IS :" + res.lastName);


        _this.setState({
            _id: studentID,
            // isLoading: false,
            firstName: res.firstName,
            lastName: res.lastName,
            // email: res.email,
            // phone: res.phone,
            // residentialAddress: res.metadata.residentialAddress,
            // schoolName: res.metadata.school,
            // schoolClassName: res.metadata.class,
            // SA2Grade: res.metadata.SA2Grade,
            // parentName: res.metadata.parentName,
            // parentNo: res.metadata.parentNo,
            // parentEmail: res.metadata.parentEmail,
            // lastActivityDate: '',
            // studentsData: (!err && res) ? res: [{}]
            }, () => {

                _this.retrieveConcepts();
                // var sData = _this.state.studentsData;
                // for (var i = 0; i < sData.length; i++) {

                //     var thisData = sData[i];
                //     var dDate = thisData['lastActivityDate'];
                //     var processDate = new Date(dDate);
                //     var dateToDisplay = processDate.toDateString();
                //     if (processDate.getFullYear()=='1970') { dateToDisplay = '-';}
                //     thisData['lastActivityDate'] = dateToDisplay;//processDate.getFullYear() + "/" + processDate.getMonth() + "/" + processDate.getDate();
                // }

                // _this.setState({
                //     studentsData: sData
                // });
            // console.log("DONE!!!");
            }
        );
    })
  },

  retrieveConcepts: function(callback) {

    callback = callback || function(){};
    var _this = this;
    var currentPager = this.state.currentPager;
    var options = {};
    options.skip = ITEM_LIMIT * (currentPager - 1);
    options.limit = ITEM_LIMIT;
    options.tree = true;
    options.max_level = 4;
    options.root = _this.state.courseID;
    // options.sort = this.state.sort || "dateCreated";
    options.conditions = {};

    AnalyticsRes.retrieveStudentConceptMap(options, function(err, res) {

      

      // console.log("CONCEPT MAP DATA IS NOW: ",conceptMapData);
      _this.setState({
        concepts: res, //res,
        isLoading:false,
        // isGettingConcepts: false
      }, ()=> {
        // console.log("res is: ",res);
        // _this.retrieveStudentAllTimeStats();
      });
    });
  },


  daysInMonth: function(iMonth, iYear) {
    return new Date(iYear, iMonth, 0).getDate();
  },
    renderHeaderRows: function() {
      var result = [],
          _this = this;
      
      result.push(<th key={'studentClassName'} className="sortable mbHeader">
              Date
              </th>);
      result.push(<th key={'noOfStudents'} className="sortable mbHeader">
              Concept
              </th>);
      result.push(<th key={'studentClassLevel'} className="sortable mbHeader">
              Wrong questions
              </th>);
      result.push(<th key={'dateCreated'} className="sortable mbHeader">
              Review
              </th>);
      return (
          <tr>
          {
              result.map((value, index) => {
              return value
              })
          }
          </tr>
      )
  },
  renderMistakesRows: function(fName,lName,callback) {

    callback = callback || function(){};
    var _this = this;

    var today = new Date();
    var yyyy = today.getFullYear();
    var mm = today.getMonth() + 1; //January is 0!
    var dd = today.getDate();//this.daysInMonth(mm,yyyy);//today.getDate(); //get last day for this month

    var result = [];

    for (var i = 0; i < 6; i++) { //get mistakes for last 6 months
      
      if (i > 0) {

        today.setDate(0); // 0 will result in the last day of the previous month
        yyyy = today.getFullYear(); //get the year for the previous month
        mm = today.getMonth() + 1; //get the previous month

        today.setDate(1); // 1 will result in the first day of the previous month

        if (mm === 0) { //if previous month is december, go back 1 year
          
          mm = 12; //and change it to 12 for december
          yyyy = today.getFullYear() - 1;
        }

        dd = this.daysInMonth(mm,yyyy); //get the last day of the previous month (i.e how many days the previous month have)
      
      } 
      // else {

      //   dd = today.getDate();
      // }

      result.push(
        <MistakesBankRow
          _id={_this.state._id}
          year={yyyy}
          month={mm}
          day={dd}
          courseID={_this.state.courseID}
          concepts={_this.state.concepts}
        />
      );
    }

    return result;
  },
  retrieveMistakes: function(fName,lName,callback) {

    callback = callback || function(){};
    var _this = this;

    var today = new Date();
    var yyyy = today.getFullYear();
    var mm = today.getMonth(); //January is 0!
    var dd = this.daysInMonth(mm,yyyy);//today.getDate(); //get last day for this month

    for (var i = 0; i < 6; i++) { //get mistakes for last 6 months

      // var lastDayOfMonth = 0;
      if (i > 0) {

        today.setDate(0); // 0 will result in the last day of the previous month
        yyyy = today.getFullYear(); //get the year for the previous month
        mm = today.getMonth(); //get the previous month

        today.setDate(1); // 1 will result in the first day of the previous month

        if (mm === 0) { //if previous month is december, go back 1 year
          
          mm = 12; //and change it to 12 for december
          yyyy = today.getFullYear() - 1;
        }

        dd = this.daysInMonth(mm,yyyy); //get the last day of the previous month (i.e how many days the previous month have)
      }

      // var currentPager = this.state.currentPager;
      var options = {};
      // options.skip = ITEM_LIMIT * (currentPager - 1);
      // options.limit = ITEM_LIMIT;
      // options.sort = this.state.sort || "dateCreated";

      options.concept_config = {};
      options.concept_config.root = _this.state.courseID;//"a234e6f6-a3ee-4bfe-9143-5c52f89ac84c"; //_id of "maths" in concepts table
      options.concept_config.leaf = true;
      options.concept_config.max_level = 4;

      options.conditions = {};

      var studentID = this.state._id;//currentURL[currentURL.length-1]; //get the current class ID

      // options.conditions.status = 'student';
      options.skip = 0;
      options.conditions.user = studentID;
      options.conditions.type = "USER_CONCEPT_PRACTICE";
      options.conditions.$or = [
          {
          "wrongAnswerCount": {
            "$gt": 0
          }
        }
      ];

      //TODO: get current date

      if (dd < 10) {
        dd = '0' + dd;
      } 
      if (mm < 10) {
        mm = '0' + mm;
      } 

      var formattedStart = '' + yyyy + mm + '01';

      options.endTime = '' + yyyy + mm + dd; //end date here
      options.startTime = formattedStart; //start date here

      // options.conditions.status = 'student';

      //TODO: call a controller to actually retrieve the mistakes from the db server
      AnalyticsRes.retrieveStudentMistakesBankForMonth(options, function(err, res) {

        // _this.setState({
        //   isLoading: false,
        //   mistakesData: (!err && res) ? res: [{}]
        // }, () => {

        // });
      });
    }
  },
  showMath: function(_id) {

    var _this = this;
    var ifUpdateConcepts = false;
    if (this.state.courseID != MATH_ID) {
      ifUpdateConcepts = true;
    }
    this.setState({
        mathButtonStyle: "mistakesButton mbSelected",
        scienceButtonStyle: "mistakesButton",
        courseID: MATH_ID,
        isLoading:ifUpdateConcepts
    },()=>{
      if (ifUpdateConcepts) {
        _this.retrieveConcepts();
      }
    });
  },
  showScience: function(_id) {
    var _this = this;

    var ifUpdateConcepts = false;
    if (this.state.courseID != SCIENCE_ID) {
      ifUpdateConcepts = true;
    }

    this.setState({
        mathButtonStyle: "mistakesButton",
        scienceButtonStyle: "mistakesButton mbSelected",
        courseID: SCIENCE_ID,
        isLoading:ifUpdateConcepts
    },()=>{
      if (ifUpdateConcepts) {
        _this.retrieveConcepts();
      }
    });
  },
  render: function() {
    var _this = this;
    return (
        <div className="students">
            
            <div className="row createStudentRow">
                <div className="col col-md-2 DivlblCreateStudent">
                    <label className="lblCreateStudent"></label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    {
                    (!_this.state.isLoading) &&
                    <label className="lblStudentInfo"><h3> {_this.state.firstName} {_this.state.lastName}'s Mistakes Bank </h3></label>
                    }
                </div>
            </div>
            <hr/>
            
            <div className="dp-inline-block">
                <button
                    value="Math"
                    onClick={this.showMath.bind(this,_this.state._id)}
                    className={_this.state.mathButtonStyle}
                >Math</button>
            </div>
            <div className="dp-inline-block">
                <button
                    value="Science"
                    onClick={this.showScience.bind(this,_this.state._id)}
                    className={_this.state.scienceButtonStyle}
                >Science</button>
            </div>
            {
              
              (!_this.state.isLoading) &&
              <div className="collection-table mbTable">
                
                <table className="table table-bordered table-striped">
                    <thead>
                    {
                        _this.renderHeaderRows()//(this.state.mode.cols)
                    }
                    </thead>
                    
                    {
                      (_this.state.courseID === MATH_ID) &&
                      this.renderMistakesRows()
                    }

                    {
                      (_this.state.courseID === SCIENCE_ID) &&
                      this.renderMistakesRows()
                    }
                    
                </table>
              </div>
            }
        </div>
    );
  }

});

module.exports = ViewStudentMistakesBank;



/** WEBPACK FOOTER **
 ** ./src/components/StudentAnalytics/ViewStudentMistakesBank.js
 **/